export const RECENTS_TAB_QUERY_PARAM = 'tab';

export type RecentsTab = 'viewed' | 'workedOn';

export const WORKED_ON_TAB = 'workedOn';
export const VIEWED_TAB = 'viewed';

export const isRecentsTab = (value?: string | null): value is RecentsTab =>
	value === WORKED_ON_TAB || value === VIEWED_TAB;

export const parseRecentsTab = (param?: string | null): RecentsTab =>
	isRecentsTab(param) ? param : VIEWED_TAB;
